import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { urls } from "../../../../../urls";
import { WIZARD_STEP_KEYS, type PublicEventStep } from "../wizardSteps";

export const useStepNavigation = (eventId: string) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: PublicEventStep | null = WIZARD_STEP_KEYS.includes(rawStep as PublicEventStep)
    ? (rawStep as PublicEventStep)
    : null;

  useEffect(() => {
    if (!currentStep) {
      navigate(urls.publicEvents.edit.go(eventId).info);
    }
  }, [currentStep, eventId, navigate]);

  const navigateToStep = (step: PublicEventStep) => {
    navigate(urls.publicEvents.edit.go(eventId)[step]);
  };

  return { currentStep, navigateToStep };
};
